var React = require('react');
var accountDataService = require('~/../../src/Foundation/ReactForms/Code/Scripts/React/accountDataService.jsx');
var apiDataConstants = require('~/../../src/Foundation/ReactForms/Code/Scripts/React/apiDataConstants.js');
var postSchemas = require('./memberJoinPostSchemas.jsx');

// Pricing is supplementary display data. A member type can reach a step with no
// product/rate type selected yet, in which case the pricing URL builder is
// intentionally skipped (ASAWEB-864) and getData rejects. That rejection must NOT
// abort the step change, so treat a skipped/failed pricing lookup as an
// empty-but-valid response ({ response: {} } keeps getStepDataFromApi's resolver
// happy without contributing any ProductInfo to step state).
var getPricingInfoOptional = function () {
    return accountDataService.getData('memberJoinPricingInfo').catch(function () {
        return { response: {} };
    });
};

var apiResponseKeys = {
    2: ['CustomerInformation'],
    3: ['Demographics', 'AddressInformation', '_Customerphones', 'ProductInfo', 'MilitaryService', 'GovernmentSector'],
    4: ['CustomerInformation', 'MasterCustomerId', 'MedicalLicensures', '_Certifications', 'ProductInfo'],
    5: ['CustomerEducationInfo', 'ProductInfo' ],
    6: ['CustomerInformation', 'ProductInfo', 'AddressInformation', 'CustomerEducationInfo']
}

var stepDeleteActions = {
    4: {
        activeLicenses: function(licenseId) {
            var url = accountDataService.memberJoinDeleteUrl.medicalLicensure();
            return postMemberJoinData(url, licenseId);
        }
    },
    5: {
        fellowships: function(licenseId) {
            var url = accountDataService.memberJoinDeleteUrl.education();
            return postMemberJoinData(url, licenseId);
        }
    }
}

var stepData = {
    2: {
        customerInformation: function() {
            return accountDataService.getData('customerInfo');
        }
    },
    3: {
        governmentSector: function() {
            return accountDataService.getData('governmentSector');
        },
        militaryBranch: function() {
            return accountDataService.getData('militaryBranch');
        },
        demographicsInfo: function() {
            return accountDataService.getData('demographics');
        },
        contactInfo: function() {
            return accountDataService.getData('memberJoinContactInfo');
        },
        phoneInfo: function() {
            return accountDataService.getData('phone');
        },
        pricingInfo: function() {
            return getPricingInfoOptional();
        }
    },
    4: {
        licenseInformation: function() {
            return accountDataService.getData('customerInfo');
        },
        activeLicenses: function() {
            return accountDataService.getData('medicalLicensure');
        },
        boardCertifications: function() {
            return accountDataService.getData('otherProCerts');
        },
        pricingInfo: function () {
            return getPricingInfoOptional();
        }
    },
    5: {
        education: function() {
            return accountDataService.getData('education');
        },
        pricingInfo: function () {
            return getPricingInfoOptional();
        }
    },
    6: {
        customerInfo: function () {
            return accountDataService.getData('customerInfo');
        },
        pricingInfo: function () {
            return accountDataService.getData('customerInfo').then((result) => {
                accountDataService.userInfo.memberJoinYearsInPractice = result.response.CustomerInformation[0].YearsInPractice;
                if (accountDataService.userInfo.memberJoinProductType && accountDataService.userInfo.memberJoinProductType.startsWith("ECY"))
                {
                    if (result.response.CustomerInformation[0].YearsInPractice == 1 || result.response.CustomerInformation[0].YearsInPractice == 2 || result.response.CustomerInformation[0].YearsInPractice == 3)
                    {
                        accountDataService.userInfo.memberJoinProductType = "ECY" + result.response.CustomerInformation[0].YearsInPractice;
                    }
                }

                return getPricingInfoOptional();

            });
        },
        contactInfo: function () {
            return accountDataService.getData('memberJoinContactInfo');
        },
        education: function () {
            return accountDataService.getData('education');
        }
    }
    
}

var stepSubmissions = {
    1: {

    },
    2: {
        // after the account is created (or they were already logged in), run through these other submissions
        saveApplicationInfoToSession: function(data) {
            var apiReadyData = postSchemas[2].saveApplicationInfoToSession(data);
            var url = accountDataService.memberJoinPostUrl.applicationInfo();
            delete apiReadyData.applicationSubmitted;
            return postMemberJoinData(url, apiReadyData);
        },
        nameInfo: function(data) {
            var apiReadyData = postSchemas[2].nameInfo(data);
            var url = accountDataService.memberJoinPostUrl.nameInfo();
            return postMemberJoinData(url, apiReadyData);
        },
        primaryPracticeLocation: function (data) {
            var apiReadyData = postSchemas[2].primaryPracticeLocation(data);
            var url = accountDataService.memberJoinPostUrl.primaryPracticeLocation();
            return postMemberJoinData(url, apiReadyData);
        }
    },
    3: {
        deleteGovernmentSector: function (data) {
            var apiReadyData = postSchemas[3].deleteGovernmentSector(data);
            var deleteUrl = accountDataService.memberJoinDeleteUrl.governmentSector();
            return postMemberJoinData(deleteUrl, apiReadyData);
        },
        addGovernmentSector: function (data) {
            var apiReadyData = postSchemas[3].addGovernmentSector(data);
            var url = accountDataService.memberJoinPostUrl.governmentSector();
            return postMemberJoinData(url, apiReadyData);
        },
        deleteMilitaryBranch: function (data) {
            var apiReadyData = postSchemas[3].deleteMilitaryBranch(data);
            var deleteUrl = accountDataService.memberJoinDeleteUrl.militaryBranch();
            return postMemberJoinData(deleteUrl, apiReadyData);
        },
        addMilitaryBranch: function(data) {
            var apiReadyData = postSchemas[3].addMilitaryBranch(data);
            var url = accountDataService.memberJoinPostUrl.militaryBranch();
            return postMemberJoinData(url, apiReadyData);
        },
        demographicsInfo: function (data) {
            var apiReadyData = postSchemas[3].demographicsInfo(data);
            var url = accountDataService.memberJoinPostUrl.demographics();
            return postMemberJoinData(url, apiReadyData);
        },
        contactInformation: function (data) {
            var apiReadyData = postSchemas[3].contactInformation(data);
            var url = accountDataService.memberJoinPostUrl.contactInfo();
            return postMemberJoinData(url, apiReadyData);
        },
        phone: function(data) {
            var apiReadyData = postSchemas[3].phone(data);
            var url = accountDataService.memberJoinPostUrl.phone();
            return postMemberJoinData(url, apiReadyData);
        }
    },
    4: {
        primaryPractice: function (data) {
            var apiReadyData = postSchemas[4].primaryPractice(data);
            var url = accountDataService.memberJoinPostUrl.primaryPracticeLocation();
            return postMemberJoinData(url, apiReadyData);
        },
        primaryDistrict: function (data) {
            var apiReadyData = postSchemas[4].primaryDistrict(data);
            var url = accountDataService.memberJoinPostUrl.primaryDistrictLocation();
            return postMemberJoinData(url, apiReadyData);
        },
        npiNumber: function(data) {
            var apiReadyData = postSchemas[4].npiNumber(data);
            var url = accountDataService.memberJoinPostUrl.customerBasicInfo();
            return postMemberJoinData(url, apiReadyData);
        },
        activeLicenses: function (data) {
            var licenses = postSchemas[4].activeLicenses(data);
            var url = accountDataService.memberJoinPostUrl.medicalLicensure();
            return postMemberJoinData(url, licenses);
        },
        boardCertifications: function(data) {
            var url = '';
            var boardCode = apiDataConstants.boardCertificationCodes.getId(data.stepState.boardCertification);
            if (boardCode) {
                var board = postSchemas[4].boardCertifications(data);
                url = accountDataService.memberJoinPostUrl.otherProCerts();
                return postMemberJoinData(url, board);
            }

            // if this far, they chose "Not Certified". Delete any existing board certs
            if (data.stepState.boardCertificationId) {
                var boardToDelete = data.stepState.boardCertificationId;
                url = accountDataService.memberJoinDeleteUrl.otherProCerts();
                return postMemberJoinData(url, [boardToDelete]);
            }
        },
        boardCredentialsDeletes: function (data) {
            // this deletes any unwanted subboards depending on the current board selection
            var toDelete = postSchemas[4].boardCredentialsDeletes(data);
            var url = accountDataService.memberJoinDeleteUrl.otherProCerts();
            return postMemberJoinData(url, toDelete);
        },
        boardCredentialsAdds: function(data) {
            var toAdd = postSchemas[4].boardCredentialsAdds(data);
            var url = accountDataService.memberJoinPostUrl.otherProCerts();
            return postMemberJoinData(url, toAdd);
        }
    },
    5: {
        medSchool: function (data) {
            var medSchool = postSchemas[5].medSchool(data);
            var url = accountDataService.memberJoinPostUrl.education();
            return postMemberJoinData(url, medSchool);
        },
        residency: function(data) {
            var residence = postSchemas[5].residency(data);
            var url = accountDataService.memberJoinPostUrl.education();
            return postMemberJoinData(url, residence);
        },
        fellowships: function(data) {
            var records = postSchemas[5].fellowships(data);
            var url = accountDataService.memberJoinPostUrl.education();
            return postMemberJoinData(url, records.length ? records : null);
        }
    },
    6:
    {
        paymentInfo: function (data) {
            var payment = postSchemas[6].paymentInfo(data);
            var url = accountDataService.memberJoinPostUrl.paymentInformation();
            return postMemberJoinData(url, payment);
    }
    }
    }


var postMemberJoinData = function (url, apiReadyData) {
    return new Promise(function(resolve, reject) {
        return accountDataService.postData(url, apiReadyData).then((resolveData) => resolve(resolveData), (resolveData) => reject(resolveData));
    });
};

var getStepData = function (step, userData) {
     return new Promise(function(resolve, reject) {
        accountDataService.userInfo.masterCustomerId = userData.unencryptedMasterCustomerId;
        accountDataService.userInfo.encryptedMasterCustomerId = userData.encryptedCustomerId;
        accountDataService.userInfo.memberJoinProductType = userData.productType;
        accountDataService.userInfo.memberJoinRateType = userData.rateType;
        accountDataService.userInfo.memberJoinState = userData.primaryPracticeLocation ;// == "USSA" ? "US" : userData.primaryPracticeLocation;
        accountDataService.userInfo.memberJoinDistrict = userData.primaryDistrictLocation;
       
        accountDataService.userInfo.memberJoinYearsInPractice = (userData.yearsInPractice == 1 || userData.yearsInPractice == 2 || userData.yearsInPractice == 3)  ?
            userData.yearsInPractice : (userData.productType && userData.productType.startsWith("EC") && userData.rateType && userData.rateType.length > 0
                && (userData.rateType.charAt(userData.rateType.length - 1) == 1
                    || userData.rateType.charAt(userData.rateType.length - 1) == 2
                    || userData.rateType.charAt(userData.rateType.length - 1) == 3
                ) ? userData.rateType.charAt(userData.rateType.length - 1) : -1);
            
        var promises = [];

        for (var getFunction in stepData[step]) {
            promises.push(stepData[step][getFunction]());
        }

        handleAllPromises(promises, resolve, reject);
    });
}

var submitStepData = function(step, data, postCache) {
    return new Promise(function (resolve, reject) {
        if (data) {
            accountDataService.userInfo.masterCustomerId = data.appState.unencryptedMasterCustomerId;
            accountDataService.userInfo.encryptedMasterCustomerId = data.appState.encryptedCustomerId;

            var promises = [];

            for (var postFunction in stepSubmissions[step]) {
                if ((JSON.stringify(postCache[step][postFunction]) !== JSON.stringify(postSchemas[step][postFunction](data))) || data.appState.currentStep === 6) {
                    promises.push(stepSubmissions[step][postFunction](data));
                }
            }

            handleAllPromises(promises, resolve, reject);
        } else {
            resolve();
        }
    });
};

var deleteStepData = function(step, action, recordId) {
    return new Promise(function(resolve, reject) {

        var promises = [];

        if (stepDeleteActions[step] && stepDeleteActions[step][action]) {
            promises.push(stepDeleteActions[step][action](recordId));
        }

        handleAllPromises(promises, resolve, reject);
    });
}

var handleAllPromises = function(promises, resolve, reject) {
    Promise.all(promises).then((responses) => resolve(responses), (responses) => reject(responses));
}

module.exports = {
    deleteStepData: deleteStepData,
    submitStepData: submitStepData,
    getStepData: getStepData,
    apiResponseKeys: apiResponseKeys
};